import { RouteObject } from "react-router-dom";
import {
  DynamicAttributeEditorPage,
  DYNAMIC_ATTRIBUTE_EDITOR_PATH,
} from "./pages";
import { DYNAMIC_ATTRIBUTES_LIST_PAGE } from "./pages/attributes";
import AttributeListPage from "./pages/attributes/attributes-list-page";
import {
  DYNAMIC_ENUM_EDITOR,
  DynamicEnumEditorPage,
} from "./pages/enum-editor";
import { RestrictDynamicAttributes } from "./shared/access/restrict-dynamic-attributes";

export const dynamicAttributeRoutes: RouteObject[] = [
  {
    path: DYNAMIC_ATTRIBUTE_EDITOR_PATH,
    element: (
      <RestrictDynamicAttributes>
        <DynamicAttributeEditorPage />
      </RestrictDynamicAttributes>
    ),
  },
  {
    path: DYNAMIC_ATTRIBUTES_LIST_PAGE,
    element: (
      <RestrictDynamicAttributes>
        <AttributeListPage />
      </RestrictDynamicAttributes>
    ),
  },
  {
    path: DYNAMIC_ENUM_EDITOR,
    element: (
      <RestrictDynamicAttributes>
        <DynamicEnumEditorPage />
      </RestrictDynamicAttributes>
    ),
  },
];
